import "./TextField_style.css";

type Props = {
    children?: string;
    type?: "normal" | "bold";
    className?: string | null;
    style?: React.CSSProperties;
    onClick?: () => void;
    numberOfLines?: number;
};

export default function TextField({
    children = "",
    type = "normal",
    className = null,
    style = undefined,
    onClick = undefined,
    numberOfLines = 1,
}: Props): JSX.Element {
    return (
        <div
            className={`text-field${type === "bold" ? ` bold` : ``}${
                className != null ? ` ${className}` : ``
            }${onClick == null ? '' : ' clickable'}`}
            style={{ ...style, maxHeight: `${numberOfLines * 1.25}em` }}
            onClick={onClick}
        >
            {children}
        </div>
    );
}
